module.exports = __webpack_public_path__ + "static/media/estres.0eab3e43.svg";